/*
    Defines the API route we are using.
*/

import axios from 'axios'
window.csrf_token = '{{ csrf_token() }}'
let xcsrf_token = window.$cookies.get('XCSRF-TOKEN')

var site_axios = axios.create({
  headers: {
    //'X-Requested-With': 'XMLHttpRequest',
    //'xsrfCookieName': 'XCSRF-TOKEN',
    //'X-CSRF-TOKEN': '7YC0Sxth7AYe4RFSjzaPf2ygLCecJhPbyXhz6vvF',
    Accept: 'application/json',
    //'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json'
  },
  timeout: 0,
  keepAlive: true
})

// LOCAL
const normalizeApiBasePath = (basePath = '') =>
  basePath.replace(/\/api\/?$/, '/').replace(/([^/])$/, '$1/')

var api_endpoint = normalizeApiBasePath(process.env.VUE_APP_API_BASE_PATH)

export const API_CONFIG = {
  SITE_AXIOS: site_axios,
  API_ENDPOINT: api_endpoint
}
